/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import NProgress from 'nprogress'

export class Api {
  private static _instance: Api

  private _axiosInstance: AxiosInstance

  private _loadCounter = 0

  private constructor() {
    Api.instance = this
    this._axiosInstance = axios.create()

    this._axiosInstance.interceptors.request.use(
      (config: AxiosRequestConfig): AxiosRequestConfig => {
        if (this._loadCounter === 0) {
          NProgress.start()
        }
        this._loadCounter += 1
        return config
      },
    )

    this._axiosInstance.interceptors.response.use(
      (value: AxiosResponse<any>) => {
        this._loadCounter -= 1
        if (this._loadCounter === 0) {
          /* Do not flicker! */
          setTimeout(() => {
            /* Still at zero? */
            if (this._loadCounter === 0) {
              NProgress.done()
            }
          }, 300)
        }
        return value
      },
      (error: any) => {
        // const status = error.response ? error.response.status : null
        // console.log('@FIXME service/api.tsx -> spinner doesnt stop spinning. axios response is:', error);
        NProgress.done()
        return Promise.reject(error)
      },
    )
  }

  public get axiosInstance(): AxiosInstance {
    return this._axiosInstance
  }

  public static get instance(): Api {
    return this._instance ?? new Api()
  }

  public static set instance(api: Api) {
    this._instance = api
  }
}
